import _ from 'underscore';

import EntityStore from 'stores/EntityStore';

import {ReviewerUser, ReviewSummary} from './ReviewConstants';

export function currentUserHandle(): string | undefined {
  return EntityStore.currentUser() ? EntityStore.currentUser().handle : undefined;
}

export function isReviewer(reviewers: Array<ReviewerUser>): boolean {
  return reviewers.find((reviewer) => reviewer.handle === currentUserHandle()) != null;
}

export function isAuditor({auditors}: ReviewSummary): boolean {
  // eslint-disable-next-line no-restricted-syntax
  return _.pluck(auditors, 'handle').includes(currentUserHandle());
}

export function hasApprovedReview(review: ReviewSummary): boolean {
  if (isAuditor(review)) {
    const auditor = _.findWhere(review.auditors, {handle: currentUserHandle()});
    return auditor != null && auditor.approved;
  } else {
    return false;
  }
}
